/**
 * @file EasyDeploy页 联系我们的请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest2 from '../baseApi2';


// 提交联系表单
export interface IFeedbackApiSubmitParam {
    // 模型类型
    model_type: string;
    // 模型名称
    model_name:string;
    // 部署芯片
    deployment_of_chip: string;
    // 联系方式
    phone: string;
    // 需求描述
    demand_desc:string;
}

export const fetchSubmit = (params: IFeedbackApiSubmitParam): Promise<request.Response> =>
    baseRequest2(
        request.post('/platform/usercase/send')
            .query({type: 15})
            .send(params)
    );
